import { UnitPipe } from './unit.pipe';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BisectAsyncPipe } from './bisect-async.pipe';
import { BisectPipe } from './bisect.pipe';
import { SafeAsyncPipe } from './safe-async.pipe';
import { SafePipe } from './safe.pipe';

@NgModule({
    providers: [SafePipe, SafeAsyncPipe, BisectPipe, BisectAsyncPipe],
    imports: [CommonModule, SafePipe, SafeAsyncPipe, BisectPipe, BisectAsyncPipe, UnitPipe],
    exports: [SafePipe, SafeAsyncPipe, BisectPipe, BisectAsyncPipe, UnitPipe],
})
export class PipesModule {}
